import { useState, useEffect } from "react";
import TextSkeleton from "../../components/SkeletonComponents/TextSkeleton";

const TempoInput = (props) => {
  const [currentTempo, setCurrentTempo] = useState({
    eccentric: props.tempo.eccentric != null ? props.tempo.eccentric : "",
    stretchedPause:
      props.tempo.stretchedPause != null ? props.tempo.stretchedPause : "",
    concentric: props.tempo.concentric != null ? props.tempo.concentric : "",
    contractedPause:
      props.tempo.contractedPause != null ? props.tempo.contractedPause : "",
  });
  const isLoading = props.isLoading;

  useEffect(() => {
    setCurrentTempo({
      eccentric: props.tempo.eccentric != null ? props.tempo.eccentric : "",
      stretchedPause:
        props.tempo.stretchedPause != null ? props.tempo.stretchedPause : "",
      concentric: props.tempo.concentric != null ? props.tempo.concentric : "",
      contractedPause:
        props.tempo.contractedPause != null ? props.tempo.contractedPause : "",
    });
  }, [props.tempo]);

  const handleEccentricChange = (event) => {
    const { value } = event.target;
    if (value.length <= 2) {
      setCurrentTempo({ ...currentTempo, eccentric: value });
    }
  };

  const handleStretchedPauseChange = (event) => {
    const { value } = event.target;
    if (value.length <= 2) {
      setCurrentTempo({ ...currentTempo, stretchedPause: value });
    }
  };

  const handleConcentricChange = (event) => {
    const { value } = event.target;
    if (value.length <= 2) {
      setCurrentTempo({ ...currentTempo, concentric: value });
    }
  };

  const handleContractedPauseChange = (event) => {
    const { value } = event.target;
    if (value.length <= 2) {
      setCurrentTempo({ ...currentTempo, contractedPause: value });
    }
  };

  const handleInputBlur = () => {
    props.onSubmit(currentTempo);
  };

  return (
    <>
      <h2 className="block text-sm font-medium text-gray-700">Tempo</h2>
      <div className="grid grid-cols-[1fr,auto,1fr,auto,1fr,auto,1fr] w-min items-center max-[396px]:grid-cols-[1fr,auto,1fr,auto]">
        {!isLoading ? (
          <div className="relative w-[60px]">
            <input
              id={"tempo-eccentric"}
              name={"tempo-eccentric"}
              autoComplete="off"
              tabIndex={-1}
              className="mt-1 pr-[24px] text-center block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
              type="number"
              min="0"
              max="59"
              maxLength="2"
              value={currentTempo.eccentric}
              onChange={handleEccentricChange}
              onBlur={handleInputBlur}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.target.blur();
                }
              }}
            />
            <span className="mt-0.5 mr-1 text-sm text-center block absolute right-0 top-1/2 -translate-y-1/2 pr-3">
              s
            </span>
          </div>
        ) : (
          <TextSkeleton height="38px" className="mt-1 w-[60px]" />
        )}
        <span className="block text-md text-gray-700 px-4">-</span>
        {!isLoading ? (
          <div className="relative w-[60px]">
            <input
              id={"tempo-stretched-pause"}
              name={"tempo-stretched-pause"}
              autoComplete="off"
              tabIndex={-1}
              className="mt-1 pr-[24px] text-center block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
              type="number"
              min="0"
              max="59"
              maxLength="2"
              value={currentTempo.stretchedPause}
              onChange={handleStretchedPauseChange}
              onBlur={handleInputBlur}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.target.blur();
                }
              }}
            />
            <span className="mt-0.5 mr-1 text-sm text-center block absolute right-0 top-1/2 -translate-y-1/2 pr-3">
              s
            </span>
          </div>
        ) : (
          <TextSkeleton height="38px" className="mt-1 w-[60px]" />
        )}
        <span className="block text-md text-gray-700 px-4 max-[396px]:text-gray-50">
          -
        </span>
        {!isLoading ? (
          <div className="relative w-[60px]">
            <input
              id={"tempo-concentric"}
              name={"tempo-concentric"}
              autoComplete="off"
              tabIndex={-1}
              className="mt-1 pr-[24px] text-center block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
              type="number"
              min="0"
              max="59"
              maxLength="2"
              value={currentTempo.concentric}
              onChange={handleConcentricChange}
              onBlur={handleInputBlur}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.target.blur();
                }
              }}
            />
            <span className="mt-0.5 mr-1 text-sm text-center block absolute right-0 top-1/2 -translate-y-1/2 pr-3">
              s
            </span>
          </div>
        ) : (
          <TextSkeleton height="38px" className="mt-1 w-[60px]" />
        )}
        <span className="block text-md text-gray-700 px-4">-</span>
        {!isLoading ? (
          <div className="relative w-[60px]">
            <input
              id={"tempo-contracted-pause"}
              name={"tempo-contracted-pause"}
              autoComplete="off"
              tabIndex={-1}
              className="mt-1 pr-[24px] text-center block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
              type="number"
              min="0"
              max="59"
              maxLength="2"
              value={currentTempo.contractedPause}
              onChange={handleContractedPauseChange}
              onBlur={handleInputBlur}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.target.blur();
                }
              }}
            />
            <span className="mt-0.5 mr-1 text-sm text-center block absolute right-0 top-1/2 -translate-y-1/2 pr-3">
              s
            </span>
          </div>
        ) : (
          <TextSkeleton height="38px" className="mt-1 w-[60px]" />
        )}
        <span className="pl-0.5 block text-xs text-gray-700 pt-1 col-[1_/_span_2] max-[396px]:row-[2] max-[396px]:mb-2">
          Eccentric (Lengthening)
        </span>
        <span className="pl-0.5 block text-xs text-gray-700 pt-1 col-[3_/_span_1] max-[396px]:col-[3_/_span_2] max-[396px]:row-[2] max-[396px]:mb-2">
          Pause (Stretched)
        </span>
        <span className="pl-0.5 block text-xs text-gray-700 pt-1 col-[5_/_span_2] max-[396px]:col-[1_/_span_2]">
          Concentric (Shortening)
        </span>
        <span className="pl-0.5 block text-xs text-gray-700 pt-1 col-[7_/_span_1] max-[396px]:col-[3_/_span_2]">
          Pause (Contracted)
        </span>
      </div>
    </>
  );
};

export default TempoInput;
